import React from 'react';
const Footer = () => {
  return (
    <footer>
      <p>
        Made with{' '}
        <span role="img" aria-label="heart">
          ❤️
        </span>{' '}
        by Jose Aurelio, Germán y Eduardo
      </p>
    </footer>
  );
};
export default Footer;
